export const events = {
  addRestDayPlanningUserProfileStart: 'Add rest day planning user profile start',
  editPlanningVersionStart: 'Edit planning version start',
  editPlanningVersionSubmit: 'Edit planning version submit',
  addNewPlanningVersionStart: 'Add new planning version start',
  addNewPlanningVersionSubmit: 'Add new planning version submit',
}
